<template>
  <v-menu min-width="300" offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        elevation="0"
        class="ml-4"
        v-on="on"
      >
        Фильтр по регионам
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click.stop.prevent="">
        <v-select
          class="my-2"
          :items="TYPES"
          :value="adminLevel"
          label="Административный уровень"
          hide-details
          :disabled="isLoading"
          @change="onChangeLevel"
        />
      </v-list-item>

      <v-list-item @click.stop.prevent="">
        <v-autocomplete
          v-model="selectedRegionsList"
          class="my-2"
          multiple
          :disabled="isLoading"
          :items="availableRegions"
          label="Регион"
          hide-details
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0" class="caption">
              {{ getDeclination(selectedRegions.length, ['Выбран', 'Выбрано', 'Выбраны']) }}
              {{ selectedRegions.length }}
              {{ getDeclination(selectedRegions.length, ['регион', 'региона', 'регионов']) }}
            </span>
          </template>
        </v-autocomplete>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { SET_ADMIN_LEVEL } from '@/store/types';
import debounce from 'lodash/debounce';
import getDeclination from '@/utils/declinationOfNumber';

const ADMIN_LEVEL_TYPES = [
  { value: 3, text: 'Федеральные округа' },
  { value: 4, text: 'Города и области' },
  { value: 5, text: 'Округа' },
  { value: 6, text: 'Городские округа и районы' },
  { value: 7, text: 'Участки' },
  { value: 8, text: 'Сельсоветы и сельские поселения' },
];

export default {
  name: 'region-filter',
  props: {
    isLoading: Boolean,
  },
  data: () => ({
    selectedRegionsList: [],
  }),
  computed: {
    ...mapState('filters', [
      'adminLevel',
      'availableRegions',
      'selectedRegions',
    ]),
  },
  watch: {
    // eslint-disable-next-line func-names
    selectedRegionsList: debounce(async function (regions) {
      await this.syncRegions(regions);
      this.$emit('selected', regions);
    }, 1000),
  },
  created() {
    this.TYPES = ADMIN_LEVEL_TYPES;
    // this.selectedRegionsList = this.selectedRegions;
    this.getDeclination = getDeclination;
  },
  methods: {
    ...mapActions('filters', ['getAvailable', 'syncRegions']),
    ...mapMutations('filters', [SET_ADMIN_LEVEL]),
    async onChangeLevel(e) {
      this[SET_ADMIN_LEVEL](e);
      await this.getAvailable();
    },
  },
};
</script>

<style scoped>

</style>
